import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { Info } from 'lucide-react';

// Small "i" info icon that reveals a field explanation on hover/tap.
// Uses a bundled lucide icon (no runtime icon fetch) so it always renders.
// Usage: <FormLabel>Field name <InfoTooltip title="What this field does" /></FormLabel>
InfoTooltip.propTypes = {
  title: PropTypes.node,
  width: PropTypes.number,
};

export default function InfoTooltip({ title, width = 16 }) {
  if (!title) return null;
  return (
    <Tooltip title={title} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={4000}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          ml: 0.5,
          verticalAlign: 'middle',
          cursor: 'help',
          color: 'secondary.main',
          '&:hover': { color: 'primary.main' },
        }}
      >
        <Info size={width} />
      </Box>
    </Tooltip>
  );
}
